export const environment = {
  isProdMode: true,
  apiUrl: 'https://api.app.dev.fundre.co',
  filesStorage: 'https://backend-filestore-fundre-dev1.s3.amazonaws.com',
  awsAmplifyConfig: {
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_vBhegb1ts',
    userPoolWebClientId: 'cloiigrr6ulrl1io8rdo926di',
  },
  googleMapsConfig: {
    staticApiKey: 'AIzaSyCg1wtpRQNhxQaPMo_-dPxMzY1lznpSnF8',
    geocodingApiKey: 'AIzaSyBEKRozbLHF6YAk2IRF4gX45VqyVfA0l1s',
  },
  authConfig: {
    enableLegacyTokenFallback: true,
    // authTokenRetryDelays: [0, 100, 150, 250, 400, 650], // optional override (ms)
  },
};
